import axios from 'axios';
import axiosDocument from './axiosDocument';


const cameraController = {
  getAccessTokenCamera(info) {
    const url = '/openapi/accessToken';
    const payload = info;
    return axiosDocument.post(url, payload);
  },

  getCamera(token, deviceId) {
    const url = `/camera/${deviceId}`;
    return axiosDocument.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },

  refreshCamera({ deviceId, typeDevice }) {
    const url = `/camera/${deviceId}/refresh?type=${typeDevice}`;
    return axiosDocument.get(url);
  },
};

export default cameraController;
